//---------------------------------------------------------
const BaseUrl = "https://backend.ayandehsazan.ir/";
// const BaseUrl = "http://188.253.3.236:8000/";
const ImageBaseUrl="https://backend.ayandehsazan.ir/media/";
const ImageBaseUrl2="https://backend.ayandehsazan.ir/";
// -----------------------------------------------------

const Apis = {
    imageUrl: ImageBaseUrl,
    baseUrl: BaseUrl,
    ImageBaseUrl2: ImageBaseUrl2,
    GET_HOME_DATA: BaseUrl + "a/act/home/",
    GET_HOME_TOP_ASSOCIATIONS: BaseUrl + "a/act/home-top-associations/",
    GET_HOME_MEDAL_TYPES: BaseUrl + "a/act/home-medal-types/",
    GET_HOME_MEDAL_COUNTS: BaseUrl + "a/act/home-medal-counts/",
    GET_HOME_SHOHRAT_AFARINAN: BaseUrl + "a/act/home-shohratafarinan/",
    GET_HOME_MASHAHIR: BaseUrl + "a/act/home-mashahir/",
    GET_FOLLOWS_BOOM: BaseUrl + "a/act/user-follows/",
    GET_HOME_PADIDEGAN: BaseUrl + "a/act/home-padidegan/",
    GET_HOME_ZOBDEGAN: BaseUrl + "a/act/home-zobdegan/",
    GET_LIST_PROVINCE: BaseUrl + "list-province/",
    GET_LIST_COUNTY: BaseUrl + "list-county/?province=",
    GET_LIST_CITY: BaseUrl + "list-city/?province=",
    GET_MY_BOOM: BaseUrl + "a/act/activity-list/following/?page_from=",
    GET_ACTIVITY_SEARCH: BaseUrl + "a/act/activity-list/search?",
    GET_MY_ACTIVITY: BaseUrl + "a/act/activity-list/my?accepted=null",
    GET_MY_FOLLOWING: BaseUrl + "a/act/following-list/",
    GET_SUGGESTED_FOLLOWING: BaseUrl + "a/act/suggested-following-list/",
    GET_SEARCH_PATTERN: BaseUrl + "a/act/my-derived-activity-list/?q=",
    GET_SEARCH_SCHOOL: BaseUrl + "a/act/school-list-in-activity-form/?q=",
    GET_SUBJECT_LIST: BaseUrl + "a/act/subject-list/",
    GET_CATEGORY_LIST: BaseUrl + "a/act/category-list/",
    GET_ACTIVITY_DETAIL: BaseUrl + "a/act/activity-detail/",
    GET_SCHOOL_DETAIL: BaseUrl + "a/act/school/",
    FOLLOW_UNIT: BaseUrl + "a/act/follow-unit/",
    LIKED_ACTIVITY: BaseUrl + "a/act/activity-like-or-dislike/",
    APPRECIATE_ACTIVITY: BaseUrl + "a/act/appreciate-activity/",
    SET_ACTIVITY_PUBLIC: BaseUrl + "a/act/set-public-activity/",
    ADD_ACTIVITY_APPRECIATE_CANDIDATE: BaseUrl + "a/act/add-activity-appreciate-candidate/",
    REPORT_ACTIVITY: BaseUrl + "a/act/activity-report/",
    PUNISH_ACTIVITY: BaseUrl + "a/act/activity-punish/",
    DERIVED_ACTIVITY: BaseUrl + "a/act/activity-derive-or-disderive/",
    ADD_ACTIVITY_COMMENT: BaseUrl + "a/act/add-activity-comment/",
    EDIT_ACTIVITY_COMMENT: BaseUrl + "a/act/update-activity-comment/",
    REMOVE_ACTIVITY_COMMENT: BaseUrl + "a/act/remove-activity-comment/",
    LIKED_DISLIKED_COMMENT: BaseUrl + "a/act/activity-comment-like-or-dislike/",
    ACTIVITY_ACCEPT: BaseUrl + "a/act/activity-accept/",
    UPDATE_CATEGORY_SUBJECTS: BaseUrl + "a/act/update-subjects-and-category-of-activity-by-mentor/",
    CHECK_NATIONAL_CODE: BaseUrl + "a/check-national-code/",
    REGISTER_STEP_ONE: BaseUrl + "a/org/register/step1/",
    REGISTER_STEP_TWO: BaseUrl + "a/org/register/step2/",
    REGISTER_STEP_THREE: BaseUrl + "a/org/register/step3/",
    REGISTER_ACTIVITY: BaseUrl + "a/act/activity-register/",
    FORGET_PASSWORD_STEP_ONE: BaseUrl + "a/org/forget/step1/",
    FORGET_PASSWORD_STEP_TWO: BaseUrl + "a/org/forget/step2/",
    FORGET_PASSWORD_STEP_THREE: BaseUrl + "a/org/forget/step3/",
};
export default Apis;
